import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Container } from '@material-ui/core';
import { INFO } from '../../style/colors';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: INFO,
    padding: '0.5rem',
    color: theme.palette.secondary.main,
    marginBottom: '1rem',
    marginTop: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius:'4px',
  },
  banner_msg: {
    fontSize: '13px',
  },
  banner_icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '25px',
    paddingRight: '8px',
  },
}));
export default function Banner({ children }) {
  const css = useStyles()
  return <Container>
    <Box className={css.banner}>
      <Box pr={2} className={css.banner_icon}>
        <InfoOutlinedIcon style={{ fontSize: "25px" }} />
      </Box>
      <Box className={css.banner_msg}>
        {children}
      </Box>
    </Box>
  </Container>
}